/* eslint-disable @typescript-eslint/no-var-requires */
import appointment from './en/appointment';
import browserSupport from './en/browserSupport';
import deviceCheck from './en/deviceCheck';
import deviceIssue from './en/deviceIssue';
import generalFaq from './en/generalFaq';
import microphoneFaq from './en/microphoneFaq';
import cameraFaq from './en/cameraFaq';
import speakerFaq from './en/speakerFaq';
import permissionDenied from './en/permissionDenied';
import waitingRoom from './en/waitingRoom';
import technicalIssue from './en/technicalIssue';
import deviceSettings from './en/deviceSettings';
import videoCall from './en/videoCall';
import footer from './en/footer';
import fullFaq from './en/fullFaq';
import controlBar from './en/controlBar';
import telehealthDeviceFaqIntro from './en/telehealthDeviceFaqIntro';
import testingStrings from './en/testingStrings';
import chat from './en/chat';
import termsConditions from './en/termsConditions';
import optumTermsAndConditions from './en/optumTermsAndConditions';

interface LangKeyValuesType {
  [prop: string]: { [prop: string]: string };
}

const langKeyValues: LangKeyValuesType = {
  GENERAL: {
    ...appointment,
    ...browserSupport,
    ...deviceCheck,
    ...generalFaq,
    ...permissionDenied,
    ...deviceIssue,
    ...footer,
    ...fullFaq,
    ...termsConditions,
    ...optumTermsAndConditions,
  },
  DEVICE_FAQ: {
    ...microphoneFaq,
    ...cameraFaq,
    ...speakerFaq,
    ...telehealthDeviceFaqIntro,
    ...testingStrings,
  },
  WAITING_ROOM: {
    ...waitingRoom,
  },
  TECHNICAL_ISSUE: {
    ...technicalIssue,
  },
  DEVICE_SETTINGS: {
    ...deviceSettings,
  },
  VIDEO_CALL: {
    ...videoCall,
  },
  CONTROL_BAR: {
    ...controlBar,
  },
  CHAT: {
    ...chat,
  },
};

export default langKeyValues;
